var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "layer1",
    d: "M18.3899 8.66028L20.9344 11.2568C20.9465 11.2691 20.9549 11.2849 20.9584 11.3023C20.9619 11.3196 20.9604 11.3377 20.9541 11.3541C20.9478 11.3706 20.9369 11.3847 20.923 11.3946C20.9091 11.4045 20.8926 11.4097 20.8758 11.4097H18.3899V21.3699H13.6747V14.9676H8.28586V21.3699H3.57064V11.4108H1.08437C1.06757 11.4108 1.05115 11.4055 1.03721 11.3956C1.02327 11.3857 1.01245 11.3717 1.00615 11.3552C0.999846 11.3388 0.998347 11.3207 1.00184 11.3034C1.00534 11.286 1.01367 11.2701 1.02577 11.2578L10.9803 1.09595L15.3587 5.56583V3.58573H18.3899V8.66028Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a2f99b74148f60b5a895d5d84cfc8e4c.svg";
export { ForwardRef as ReactComponent };